const extensionsPermeses = [".gif", ".jpg", ".jpeg", ".png"];
const tipusImatgePermesos = ["image/gif", "image/jpeg", "image/png"];

export const extensionsPermesesEnString = extensionsPermeses.join();

export const fitxerTipusNoPermes = tipusFitxer => {
  return !tipusImatgePermesos.includes(tipusFitxer);
};
